import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const renderHeader = (header) => ({
  align: "center",
  flex: 1,
  headerAlign: "center",
  renderHeader: () => (
    <span style={{ whiteSpace: "pre-line", fontWeight: 600 }}>
      {header.headerName}
    </span>
  ),
  ...header,
});
const renderHeaderGroup = (header) => ({
  headerAlign: "center",
  renderHeaderGroup: () => <strong>{header.groupId}</strong>,
  ...header,
});

export default function SortableTable({
  columnGroupingModel,
  columns,
  ...props
}) {
  const updatedColumnGroupingModel = columnGroupingModel
    ? columnGroupingModel.map(renderHeaderGroup)
    : undefined;

  return (
    <Box sx={{ pageBreakInside: "avoid", width: "100%" }}>
      <DataGrid
        experimentalFeatures={{ columnGrouping: !!columnGroupingModel }}
        columns={columns.map(renderHeader)}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 30,
            },
          },
        }}
        pageSizeOptions={[30]}
        checkboxSelection={false}
        disableRowSelectionOnClick
        columnGroupingModel={updatedColumnGroupingModel}
        sx={{
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            "& .MuiDataGrid-row": {
              "&:nth-of-type(2n)": {
                backgroundColor: "rgba(235, 235, 235, .7)", // color every other row grey
              },
            },
          },
          // edited from code by Ryan Cogswell. [data grid] Easily allow header text to wrap.
          // Retrieved from https://github.com/mui/mui-x/issues/898
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            whiteSpace: "normal",
            lineHeight: "normal",
          },
          "& .MuiDataGrid-columnHeader": {
            height: "unset !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            maxHeight: "168px !important",
          },
        }}
        {...props}
      />
    </Box>
  );
}

SortableTable.propTypes = {
  columnGroupingModel: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};
